import { requestGet } from '@/common/request';

export interface activityAssociationParams {
  planCode: string | null;
  roomId: string | null;
}

export interface activityAssociationRes {
  ret: string;
  msg: string;
  data: {
    tibaoId?: string;
    replacedTibaoId?: string;
    replacedActName?: string;
  };
}

//会场运营 - 查询会场关联的提报活动与通天塔活动
export async function activityAssociation(params: activityAssociationParams): Promise<activityAssociationRes> {
  return await requestGet('/room/activityAssociation', params);
}
